module.exports = __webpack_public_path__ + "media/bgm.bc6ce7fc.mp3";